import type { ICellRendererParams } from 'ag-grid-community'
import type { ReactElement } from 'react'

const HintCellRenderer = (params: ICellRendererParams): ReactElement => {
  if (params.value == 'rip') {
    return <span style={{ fontSize: '16px' }}>☠️</span>
  } else if (params.value == 'top') {
    return <span style={{ fontSize: '16px' }}>🔥</span>
  } else if (params.value == 'warning') {
    return <span style={{ fontSize: '16px' }}>🤐</span>
  } else if (params.value == 'wait') {
    return <span style={{ fontSize: '16px' }}>⏳</span>
  } else if (params.value == 'empty') {
    return <span style={{ fontSize: '16px' }}>🚷</span>
  }

  return <></>
}

export default HintCellRenderer
